module.exports = __webpack_public_path__ + "static/media/eyebag.94894868.svg";